import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import GraphicDesingerMokup from "./GraphicDesignerMokup";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { FinalQuotationSchema } from "../../../ValidationSchema";
import SupplierApprovalQuotes from "./SupplierApprovalQuotes";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import AdminFinalQuotation from "./AdminFinalQuotation";
import { useMediaQuery } from "react-responsive";
import AssignSalesExecutiveModal from "./AssignSalesExecutive";
import AssignSalesExecutiveAddForm from "./AssignSalesExecutiveAddForm";
import AddGraphicDesignModal from "../DesignStudio/addGraphicDesigner";
import XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import { formatMoney } from "../../../utils/money";
import Modal from "../../../Components/Modal";
import OrderSpecsModal, {
  ProductImageStack,
  ProductImagesModal,
  displayValue,
} from "../../../Components/OrderSpecsModal";

const REACT_APP_IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const request = localStorage.getItem("request");

const ProductListBuyer = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  let is_alert = false;
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [buyerId, setBuyerId] = useState(() => {
    return localStorage.getItem("buyer_id");
  });

  const [orderIds, setOrderIds] = useState(() => {
    return localStorage.getItem("order_id");
  });

  const handleRowClick = (id, order_id) => {
    const newId = buyerId === id ? null : id;
    setBuyerId(newId);
    const newOrderId = orderIds === order_id ? null : order_id;
    setOrderIds(newOrderId);

    if (newOrderId) {
      localStorage.removeItem("order_id");
    }

    if (newId) {
      localStorage.removeItem("buyer_id");
    } else {
      localStorage.removeItem("buyer_id");
    }
  };

  const { userId } = useParams();

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [showDesignModal, setShowDesignModal] = useState(false);
  const [usersId, setUserId] = useState(0);
  const [orderId, setOrderId] = useState(0);
  const [userName, setUserName] = useState("");
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [finalPrice, setFinalPrice] = useState("");
  const [finalDescription, setFinalDescription] = useState("");
  const [approvalDesc, setApprovalDesc] = useState("");
  const [showFinalApprovalModal, setShowFinalApprovalModal] = useState(false);
  const [productApprovalData, setproductApprovalData] = useState("");
  const [showSupplierQuotesModal, setShowSupplierQuotesModal] = useState(false);
  const [monthFilter, setMonthFilter] = useState("");
  const [showGDModal, setShowGDModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // Order whose full spec sheet (specs + product images) is open.
  const [specsItem, setSpecsItem] = useState(null);
  // Order whose product-image gallery is open.
  const [galleryItem, setGalleryItem] = useState(null);
  // Design-mockup image URLs currently open in the same lightweight viewer
  // (was opening the full "manage designs" modal on a plain image click).
  const [designGalleryImages, setDesignGalleryImages] = useState(null);
  const [showAddModal, setAddShowModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const monthQuery = monthFilter ? `&month=${monthFilter}` : "";
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;

  const handleOpenModal = (userId) => {
    setUserId(userId);
    setShowModal(true);
  };

  const handleOpenGDModal = (userId, orderId) => {
    setUserId(userId);
    setShowGDModal(true);
    setOrderId(orderId);
  };

  const handleCloseGDModal = () => {
    setShowGDModal(false);
  };

  const handleAddOpenModal = () => {
    setAddShowModal(true);
  };

  const handleAddCloseModal = () => {
    setAddShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSupplierApprovalQuotesOpenModal = (
    userId,
    orderId,
    product_id,
  ) => {
    setUserId(userId);
    setOrderId(orderId);
    setproductApprovalData(product_id);
    setShowSupplierQuotesModal(true);
  };

  const handleSupplierApprovalQuotesCloseModal = () => {
    setShowSupplierQuotesModal(false);
  };

  const handleDesignOpenModal = (userId, orderId) => {
    setUserId(userId);
    setOrderId(orderId);
    setShowDesignModal(true);
  };

  const handleDesignCloseModal = () => {
    setShowDesignModal(false);
  };

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const handleWhatsAppClick = (phoneNumber) => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  const exportToExcel = async () => {
    try {
      if (!data || data.length === 0) {
        alert("No data to export.");
        return;
      }

      // 🔹 Flatten all orders (exclude unwanted fields)
      const exportData = data.flatMap((item, index) => {
        const user = item.user || {};
        const cleanOrder = {
          "Sr. No.": index + 1,
          order_id: item.order_id,
          product_id: item.product_id,
          user_id: item.user_id,
          title: item.title,
          size: item.size,
          final_price: item.final_price,
          final_description: item.final_description,
          quantity: item.quantity,
          material_color: item.material_color,
          print_coverage: item.print_coverage,
          order_status: item.order_status,
          order_type: item.order_type,
          order_placed: item.order_placed,
          sales_executive_assigned: item.sales_executive_assigned,
          graphic_designer_assigned: item.graphic_designer_assigned,
          design_received: item.design_received,
          quotation_received: item.quotation_received,
          order_tracking: item.order_tracking,
          supplier_assigned: item.supplier_assigned,
          order_completed: item.order_completed,
          created_by: item.created_by,
          updated_by: item.updated_by,
          is_deleted: item.is_deleted,
          is_active: item.is_active,
          quotation_approved: item.quotation_approved,
          sales_executive_id: item.sales_executive_id,
          graphic_designer_id: item.graphic_designer_id,
          quotation_price: item.quotation_price,
          quotation_remark: item.quotation_remark,
          quotation_description: item.quotation_description,
          product_description: item.product_description,
          created_at: new Date(item.created_at).toLocaleString("en-IN"),
          updated_at: new Date(item.updated_at).toLocaleString("en-IN"),
          mediaFiles:
            item.mediaFiles?.map((f) => f.media_file).join(", ") || "",
          user_name: user?.name || "",
          user_email: user?.email || "",
          user_phone: user?.phone || "",
          user_company: user?.company_name || "",
        };
        return cleanOrder;
      });

      if (exportData.length === 0) {
        alert("No valid records found.");
        return;
      }

      // 🔹 Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData, { origin: "A2" });
      const headers = Object.keys(exportData[0]);
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

      // 🔹 Column widths
      worksheet["!cols"] = headers.map((h) => ({
        wch: Math.max(15, h.length + 2),
      }));

      // 🔹 Workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Buyer Orders");

      // Convert workbook to XlsxPopulate
      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const xpop = await XlsxPopulate.fromDataAsync(wbout);
      const sheet = xpop.sheet("Buyer Orders");

      // === Styling ===
      const endCol = sheet.usedRange().endCell().columnName();
      const endRow = sheet.usedRange().endCell().rowNumber();

      // Header row
      const headerRow = sheet.range(`A1:${endCol}1`);
      headerRow.style({
        bold: true,
        horizontalAlignment: "center",
        verticalAlignment: "center",
        fill: "ADD8E6",
        border: true,
      });

      // Data rows
      for (let i = 2; i <= endRow; i++) {
        const row = sheet.range(`A${i}:${endCol}${i}`);
        row.style({
          border: true,
          horizontalAlignment: "left",
          verticalAlignment: "center",
        });
        if (i % 2 === 0) row.style({ fill: "F2F2F2" });
      }

      // 🔹 Save File
      const blob = await xpop.outputAsync();
      saveAs(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        "buyer-orders.xlsx",
      );

      toast.success("Excel exported successfully!");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export Excel file.");
    }
  };

  const handleCallClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const ProductData = async () => {
    const token = localStorage.getItem("Token");
    const monthQuery = monthFilter ? `&month=${monthFilter}` : "";
    const searchQuery = search ? `&search=${search}` : "";
    const limit = 10; // fixed limit

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/admin/offline_buyer/order/${userId}?page=${page}&limit=${limit}${searchQuery}${monthQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = res?.data?.data?.orders || [];
      const pages = res?.data?.data?.pagination.totalPages || 0;

      let filteredData = [];
      if (userType === "admin") {
        filteredData = data;
      } else if (userType === "subadmin") {
        filteredData = data.filter(
          (order) => order.sales_executive_id === user.user_id,
        );
      }

      if (filteredData.length > 0) {
        setUserName(filteredData[0]?.user?.name || "");
        setTotalPage(pages);
        setData(filteredData);
      } else {
        setUserName("No Data");
        setTotalPage(0);
        setData([]);
      }
    } catch (err) {
      if (err?.response?.data?.message === "Unauthorized!") {
        Navigate("/");
      } else {
        console.error("API error", err);
      }
    }
  };

  useEffect(() => {
    if (location?.state) {
      if (!is_alert) {
        // toast.success(`Viewing products of ${location?.state?.userName}`);
      }
      is_alert = true;
    }
    ProductData();
    window.history.replaceState({}, "");
  }, [page, search, request]);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectorderid, setSelectorderid] = useState(null);
  const [selectedFinalOrderId, setSelectedFinalOrderId] = useState(null);
  const [selectedFinalOrder, setSelectedFinalOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [oldPrice, setOldPrice] = useState(0);
  const [QuotationAprroved, setQuotationAprroved] = useState(0);
  const [Price, setPrice] = useState(0);

  const [initialValues] = useState({
    final_description: "",
    final_price: "",
  });

  const HandleActiveDeactive = (
    orderassignedId,
    price,
    status,
    oldprice,
    orderid,
  ) => {
    setOldPrice(oldprice);
    setQuotationAprroved(status);
    setSelectedOrderId(orderassignedId);
    setShowApprovalModal(true);
    setSelectorderid(orderid);
  };

  const AddFinalQuotation = useFormik({
    initialValues: initialValues,
    onSubmit: async (values, action) => {
      if (QuotationAprroved == "pending" || QuotationAprroved === "") {
        Swal.fire({
          icon: "warning",
          title: "In Progress",
          text: "Please Approve a quote & assign supplier before sending amount to buyer.",
        });
        return; // stop execution
      }

      if (parseFloat(values.final_price) <= parseFloat(oldPrice)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Price",
          text: `Quotation price should be more than ₹${oldPrice}.`,
        });
        return; // Stop execution here
      }

      const result = await Swal.fire({
        title: "Are you Sure?",
        text:
          status === 1
            ? "You are about to approve this quotation."
            : "You don't want to take this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: status === 1 ? "#007bff" : "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: status === 1 ? "Yes, Approve" : "Yes, Reject",
      });

      if (!result.isConfirmed) return;

      const data = {
        order_id: selectorderid,
        price: values.final_price,
        description: values.final_description,
      };

      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/quotation/send/buyer/price/${selectedOrderId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res?.data?.message,
              timer: 2000,
              showConfirmButton: false,
            });
            setShowApprovalModal(false);
            //Navigate(`/admin/buyer/list`, { state: res.data.msg });
            ProductData();
            window.location.reload();
            action.resetForm();
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: err?.response?.data?.message || "Something went wrong",
          });
        });
    },
  });

  // The modal needs final_price / final_description, which live on the order
  // row the caller already has — keep the row, not just the id.
  const handleOpenFinalQuotation = (orderRow, price) => {
    const row = typeof orderRow === "object" ? orderRow : null;
    setSelectedFinalOrder(row);
    setSelectedFinalOrderId(row ? row.order_id : orderRow);
    setPrice(price);
    setShowFinalApprovalModal(true);
  };

  const handleFinalCloseModal = () => {
    setShowFinalApprovalModal(false);
  };

  const renderStatusBadge = (status) => {
    const statusStyles = {
      Pending: {
        label: "Pending",
        bg: "#fdecec",
        color: "#d63333",
      },
      Assigned: {
        label: "Assigned",
        bg: "#e0f0ff",
        color: "#0d6efd",
      },
      Process: {
        label: "Process",
        bg: "#d1f7d6",
        color: "#0f9d58",
      },
      AdminApprovalPending: {
        label: "Admin Approval Pending",
        bg: "#fff3cd",
        color: "#856404",
      },
      Approved: {
        label: "Approved",
        bg: "#d1f7d6",
        color: "#0f9d58",
      },
      Rejected: {
        label: "Rejected",
        bg: "#fdecec",
        color: "#d63333",
      },
      WaitingForFinalApproval: {
        label: "Buyer Approval Pending",
        bg: "#fff3cd",
        color: "#856404",
      },
      Completed: {
        label: "Completed",
        bg: "#eaf2ff",
        color: "#0c63e7",
      },
    };

    const currentStatus = statusStyles[status] || statusStyles.Pending;

    return (
      <span
        style={{
          backgroundColor: currentStatus.bg,
          color: currentStatus.color,
          padding: "3px 10px",
          borderRadius: "15px",
          fontSize: "13px",
          fontWeight: 500,
        }}
      >
        {currentStatus.label}
      </span>
    );
  };

  const renderMobileCard = (item, index) => (
    <div
      key={index}
      className="card mb-3"
      style={{
        backgroundColor:
          buyerId === String(item?.user_id) &&
          orderIds === String(item?.order_id)
            ? "#e3f2fd"
            : "white",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "15px",
      }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between mb-2">
          <strong>Order ID:</strong>
          <span>{item?.order_id}</span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <strong>Title:</strong>
          <span>{item?.title}</span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <strong>Size:</strong>
          <span>{displayValue(item?.size)}</span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <strong>Quantity:</strong>
          <span>{item?.quantity || 0}</span>
        </div>

        {/* Supplier Assignment Status */}
        <div className="d-flex justify-content-between mb-2">
          <strong>Supplier Status:</strong>
          <span>
            {item?.supplier_assigned ? (
              <span className="badge badge-success">Assigned</span>
            ) : (
              <span className="badge badge-danger">Not Assigned</span>
            )}
          </span>
        </div>

        {/* Sales Executive Status - Only for admin */}
        {userType === "admin" && (
          <div className="d-flex justify-content-between mb-2">
            <strong>SE Status:</strong>
            <span>
              {item?.sales_executive_id != null ? (
                <span style={{ color: "green" }}>Assigned</span>
              ) : (
                <span style={{ color: "red" }}>Pending</span>
              )}
            </span>
          </div>
        )}

        {/* Graphic Designer Status */}
        {(userType === "admin" || userType === "subadmin") && (
          <div className="d-flex justify-content-between mb-2">
            <strong>GD Status:</strong>
            <span>
              {item?.graphic_designer_id ? (
                <span style={{ color: "green" }}>Assigned</span>
              ) : (
                <span style={{ color: "red" }}>Pending</span>
              )}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-between mb-2">
          <strong>Assign Supplier:</strong>
          <div style={{ display: "flex", gap: "8px" }}>
            <div
              onClick={() =>
                Navigate(
                  `/admin/buyer/assign-orders?user_id=${item?.order_id}`,
                  {
                    state: {
                      order_id: item?.order_id,
                    },
                  },
                )
              }
              style={{ cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#515365"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4a2 2 0 0 0 1-1.73z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
            </div>

            <div
              onClick={() => {
                const supplierIds = [
                  ...new Set(
                    item?.product
                      ?.filter((i) => i.supplier_id !== null)
                      .map((i) => i.supplier_id),
                  ),
                ];
                Navigate("/admin/assign-supplier", {
                  state: {
                    orderId: item?.order_id,
                    supplierIds: supplierIds,
                    product_id: item?.product_id,
                    // So the assign-supplier page can exclude this order's
                    // own buyer from the list of suppliers it can assign —
                    // they can be a supplier account elsewhere too.
                    buyerUserId: item?.user_id,
                    route: `/admin/buyer/product-list/${item.user_id}`,
                  },
                });
              }}
              style={{ cursor: "pointer" }}
            >
              <svg
                stroke="#515365"
                fill="#515365"
                strokeWidth="0"
                viewBox="0 0 576 512"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"></path>
              </svg>
            </div>
          </div>
        </div>

        {/* Assign SE/GD Button for Admin/Subadmin */}
        {userType !== "Graphic Designer" && (
          <div className="d-flex justify-content-between mb-2">
            <strong>Assign {userType === "admin" ? "SE/GD" : "GD"}:</strong>
            <div
              onClick={() => {
                const isDisabled =
                  (userType === "admin" &&
                    item?.sales_executive_id !== null &&
                    item?.graphic_designer_id !== null) ||
                  (userType === "subadmin" &&
                    item?.graphic_designer_id !== null);

                if (isDisabled) return;
                handleOpenModal(item?.user_id);
              }}
              style={{
                cursor: "pointer",
                opacity:
                  (userType === "admin" &&
                    item?.sales_executive_id !== null &&
                    item?.graphic_designer_id !== null) ||
                  (userType === "subadmin" &&
                    item?.graphic_designer_id !== null)
                    ? 0.5
                    : 1,
              }}
            >
              <svg
                stroke="#515365"
                fill="#515365"
                strokeWidth="0"
                viewBox="0 0 576 512"
                height="20"
                width="20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"></path>
              </svg>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-between mb-2">
          <strong>Supplier's Quotes:</strong>
          <div
            onClick={() => {
              const product = item.product.filter(
                (i) => i.status == "waiting_for_final_approval",
              );
              Navigate(
                `/admin/revert-back/supplier/${item.product_id}/${item?.order_id}`,
                {
                  state: {
                    product_id: item?.product_id,
                    order_assigned_id: product.order_assigned_id,
                    title: item?.title,
                    quantity: item?.quantity,
                    size: item?.size,
                    order_id: item?.order_id,
                  },
                },
              );
            }}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#515365"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            {request === "Send Quotation" &&
              orderIds?.includes(item?.order_id?.toString()) && (
                <span
                  style={{
                    position: "absolute",
                    top: "-2px",
                    right: "-2px",
                    width: "8px",
                    height: "8px",
                    backgroundColor: "red",
                    borderRadius: "50%",
                  }}
                />
              )}
          </div>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <strong>Graphic Designer:</strong>
          <div style={{ display: "flex", alignItems: "center" }}>
            {item.designs
              ?.filter((design) => design?.design_url)
              .slice(0, 3)
              .map((design, i, arr) => (
                <img
                  key={i}
                  src={`${REACT_APP_IMAGE_URL}${design?.design_url}`}
                  onClick={() =>
                    setDesignGalleryImages(
                      item.designs
                        .filter((d) => d?.design_url)
                        .map((d) => d.design_url),
                    )
                  }
                  alt={`Design ${i + 1}`}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid white",
                    marginLeft: i !== 0 ? "-10px" : "0px",
                    zIndex: arr.length - i,
                    cursor: "pointer",
                  }}
                />
              ))}

            {item.designs?.filter((design) => design?.design_url).length >
              3 && (
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: "#d8d8d8",
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                  marginLeft: "-10px",
                  border: "2px solid white",
                  zIndex: 0,
                }}
              >
                +
                {item.designs?.filter((design) => design?.design_url).length -
                  3}
              </div>
            )}
          </div>
        </div>
        {user.user_type === "admin" && (
          <div className="d-flex justify-content-between mb-2">
            <strong>Admin Approval:</strong>
            <div
              onClick={() => {
                const product = item.product.find(
                  (i) => i.status === "waiting_for_final_approval",
                );
                const isDisabled =
                  !product ||
                  product.status == "approved" ||
                  item.final_price != null;

                if (isDisabled) return;

                HandleActiveDeactive(
                  product.order_assigned_id,
                  item?.supplier_to_admin_quotation_price
                    ? item?.supplier_to_admin_quotation_price
                    : item.final_price,
                  product.status,
                  product.admin_quotation_price
                    ? product.supplier_to_admin_quotation_price
                    : product.quotation_price,
                  item?.order_id,
                );
              }}
              style={{
                cursor: !item.product?.find(
                  (i) => i.status === "waiting_for_final_approval",
                )
                  ? "not-allowed"
                  : "pointer",
                opacity: !item.product?.find(
                  (i) => i.status === "waiting_for_final_approval",
                )
                  ? 0.5
                  : 1,
              }}
            >
              {item.ApprovedBy === "Approved" ? (
                <svg width="60" height="24" viewBox="0 0 70 30">
                  <rect width="70" height="30" rx="15" fill="#007bff" />
                  <circle cx="52" cy="15" r="12" fill="white" />
                  <text
                    x="10"
                    y="19"
                    fill="white"
                    fontSize="12"
                    fontWeight="bold"
                  >
                    Yes
                  </text>
                </svg>
              ) : (
                <svg width="60" height="24" viewBox="0 0 70 30">
                  <rect width="70" height="30" rx="15" fill="#dc3545" />
                  <circle cx="18" cy="15" r="12" fill="white" />
                  <text
                    x="38"
                    y="19"
                    fill="white"
                    fontSize="12"
                    fontWeight="bold"
                  >
                    No
                  </text>
                </svg>
              )}
            </div>
          </div>
        )}
        <div className="d-flex justify-content-between mb-2">
          <strong>Final Quotation:</strong>
          <div
            onClick={() =>
              handleOpenFinalQuotation(item, item?.price)
            }
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                minWidth: "50px",
                minHeight: "24px",
                lineHeight: "24px",
                textAlign: "center",
                padding: "0 8px",
                border: "2px solid #0d6efd",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: 500,
                color: "#212529",
              }}
            >
              {item?.final_price || "0"}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" stroke="#17a2b8" strokeWidth="2" />
              <line
                x1="12"
                y1="8"
                x2="12"
                y2="8"
                stroke="#17a2b8"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="12"
                y1="12"
                x2="12"
                y2="16"
                stroke="#17a2b8"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <strong>Order Status:</strong>
          {(() => {
            const product =
              item.product.find((i) => i.status === "approved") ||
              item.product.find((i) => i.status === "rejected") ||
              item.product.find(
                (i) => i.status === "waiting_for_final_approval",
              ) ||
              item.product.find((i) => i.status === "pending");

            if (!product) return "—";

            let mappedStatus = "";
            switch (product.status) {
              case "approved":
                mappedStatus = "Approved";
                break;
              case "rejected":
                mappedStatus = "Rejected";
                break;
              case "waiting_for_final_approval":
                mappedStatus = "WaitingForFinalApproval";
                break;
              case "pending":
                mappedStatus = "Pending";
                break;
              default:
                mappedStatus = "Pending";
                break;
            }

            return renderStatusBadge(mappedStatus);
          })()}
        </div>

        <div className="d-flex justify-content-between">
          <strong>Action:</strong>
          <div style={{ display: "flex", gap: "8px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#515365"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              onClick={() =>
                Navigate("/admin/buyer/show", { state: { item: item } })
              }
              style={{ cursor: "pointer" }}
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => handleCallClick(item.user?.phone)}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#34B7F1"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ cursor: "pointer" }}
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.1 5.18 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.72 12 12 0 0 0 .56 2.57 2 2 0 0 1-.45 2.11L9 11a16 16 0 0 0 5 5l1.6-1.1a2 2 0 0 1 2.1-.45 12 12 0 0 0 2.57.56A2 2 0 0 1 22 16.92z" />
            </svg>

            <svg
              stroke="#25D366"
              fill="#25D366"
              strokeWidth="0"
              onClick={() => handleWhatsAppClick(item.user?.phone)}
              viewBox="0 0 448 512"
              height="20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              style={{ cursor: "pointer" }}
            >
              <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="al">
        <Toaster position="top-center" reverseOrder={false} />

        <div className="al-head">
          <div>
            <h1 className="al-title">Buyer Product List</h1>
            <p className="al-sub">
              Packaging orders &amp; their production workflow for this buyer.
            </p>
          </div>
          <div className="al-head__actions">
            {userType === "admin" && (
              <button type="button" className="al-btn" onClick={exportToExcel}>
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Export
              </button>
            )}
            <button
              type="button"
              className="al-btn"
              onClick={() => Navigate(-1)}
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </button>
          </div>
        </div>

        <div className="bpl-buyer">
          <div className="bpl-buyer__avatar">
            {(userName || "Buyer").trim().slice(0, 2).toUpperCase()}
          </div>
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                flexWrap: "wrap",
              }}
            >
              <h2 className="bpl-buyer__name">{userName || "Buyer"}</h2>
              <span
                className="al-pill"
                style={{
                  background: "var(--color-info-bg)",
                  color: "var(--color-info-text)",
                }}
              >
                Buyer
              </span>
            </div>
            <p className="bpl-buyer__sub">
              Orders &amp; production workflow overview
            </p>
          </div>
          <div className="bpl-buyer__stats">
            <div className="bpl-stat">
              <div className="bpl-stat__num">{data?.length || 0}</div>
              <div className="bpl-stat__lbl">Active orders</div>
            </div>
            <div className="bpl-stat">
              <div className="bpl-stat__num">
                {(data || [])
                  .reduce((s, i) => s + Number(i?.quantity || 0), 0)
                  .toLocaleString("en-IN")}
              </div>
              <div className="bpl-stat__lbl">Total quantity</div>
            </div>
          </div>
        </div>

        <div className="statbox widget box box-shadow bpl-card">
          <div className="widget-content widget-content-area p-0 box-shadow-none">
            <div className="table-responsive">
              <div
                id="default-ordering_wrapper"
                className="dataTables_wrapper container-fluid dt-bootstrap4"
              >
                <div className="al-toolbar">
                  <div className="al-search">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="var(--color-text-tertiary)"
                      strokeWidth="2"
                      strokeLinecap="round"
                    >
                      <circle cx="11" cy="11" r="7" />
                      <path d="m21 21-4.3-4.3" />
                    </svg>
                    <input
                      type="search"
                      placeholder="Search orders by ID, product…"
                      onChange={(e) => setSearch(e?.target?.value)}
                    />
                  </div>
                  <div className="al-select">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <select
                      value={monthFilter}
                      onChange={(e) => {
                        setMonthFilter(e.target.value);
                        ProductData();
                      }}
                    >
                      <option value="">Select Month</option>
                      <option value="All">All</option>
                      <option value="1">Last 1 Month</option>
                      <option value="3">Last 3 Months</option>
                      <option value="6">Last 6 Months</option>
                    </select>
                  </div>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: "11.5px",
                      color: "var(--color-text-tertiary)",
                      fontWeight: 600,
                    }}
                  >
                    Tap a row to view its workflow
                  </span>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <></>
                    {/*  */}
                    {isMobile ? (
                      data?.length !== 0 ? (
                        data?.map((item, index) =>
                          renderMobileCard(item, index),
                        )
                      ) : (
                        <div className="text-center fw-bold p-3">
                          <h5>No Record Found</h5>
                        </div>
                      )
                    ) : (
                      // 👉 You can replace this with your desktop view JSX
                      <div className="bpl-workspace">
                        <div className="al-tablewrap">
                          <div style={{ minWidth: 720 }}>
                            <div
                              className="al-thead"
                              style={{
                                gridTemplateColumns:
                                  "90px 1.5fr 1fr .8fr 1fr 44px",
                              }}
                            >
                              <span className="al-th">Order ID</span>
                              <span className="al-th">Title</span>
                              <span className="al-th">Size</span>
                              <span className="al-th">Quantity</span>
                              <span className="al-th">Order Status</span>
                              <span className="al-th al-th--right" />
                            </div>

                            {data?.length !== 0 ? (
                              data?.map((item, index) => {
                                const isOpen = expandedIndex === index;
                                const highlighted =
                                  buyerId === String(item?.user_id) &&
                                  orderIds === String(item?.order_id);
                                const sizeText = displayValue(item?.size);
                                const st = (() => {
                                  const s = String(
                                    item?.order_status || "",
                                  ).toLowerCase();
                                  if (
                                    s.includes("complete") ||
                                    s.includes("deliver")
                                  )
                                    return {
                                      bg: "var(--color-success-bg)",
                                      color: "var(--color-success-text)",
                                    };
                                  if (
                                    s.includes("reject") ||
                                    s.includes("cancel")
                                  )
                                    return {
                                      bg: "var(--color-danger-bg)",
                                      color: "var(--color-danger-text)",
                                    };
                                  if (s.includes("pending"))
                                    return {
                                      bg: "var(--color-warning-bg)",
                                      color: "var(--color-warning-text)",
                                    };
                                  if (
                                    s.includes("track") ||
                                    s.includes("progress") ||
                                    s.includes("received") ||
                                    s.includes("quotation")
                                  )
                                    return {
                                      bg: "var(--color-info-bg)",
                                      color: "var(--color-info-text)",
                                    };
                                  return {
                                    bg: "var(--color-surface-2)",
                                    color: "var(--color-text-secondary)",
                                  };
                                })();
                                return (
                                  <div className="bpl-order" key={index}>
                                    <div
                                      className="bpl-summary"
                                      style={{
                                        gridTemplateColumns:
                                          "90px 1.5fr 1fr .8fr 1fr 44px",
                                        background: highlighted
                                          ? "var(--color-primary-weak)"
                                          : undefined,
                                      }}
                                      onClick={() => {
                                        setExpandedIndex(isOpen ? null : index);
                                        handleRowClick(
                                          (item.user_id, item?.order_id),
                                        );
                                      }}
                                    >
                                      <span
                                        className="al-mono"
                                        style={{
                                          color: "var(--color-primary)",
                                          fontWeight: 700,
                                        }}
                                      >
                                        #{item?.order_id}
                                      </span>
                                      <span className="al-name">
                                        {item?.title}
                                      </span>
                                      <span
                                        className="al-mono al-muted al-ellipsis"
                                        title={sizeText}
                                      >
                                        {sizeText}
                                      </span>
                                      <span className="al-mono al-muted">
                                        {item?.quantity || 0}
                                      </span>
                                      <span>
                                        <span
                                          className="al-pill"
                                          style={{
                                            background: st.bg,
                                            color: st.color,
                                          }}
                                        >
                                          {item?.order_status || "—"}
                                        </span>
                                      </span>
                                      <span
                                        className="bpl-chev"
                                        style={{
                                          transform: isOpen
                                            ? "rotate(90deg)"
                                            : "none",
                                        }}
                                      >
                                        <svg
                                          width="17"
                                          height="17"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2.2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                      </span>
                                    </div>

                                    {isOpen && (
                                      <div className="bpl-detail">
                                        {(() => {
                                          // Real order of events: a Sales
                                          // Exec and Graphic Designer are
                                          // assigned first; the GD produces a
                                          // mockup; only then is a Supplier
                                          // sourced against that mockup to
                                          // quote; the supplier's quote is
                                          // negotiated and admin sends a
                                          // final quotation to the buyer; the
                                          // buyer approves it; tracking
                                          // begins. The previous order
                                          // (Supplier, Sales Exec, Designer,
                                          // Quotes, Mockup, Final, Approval)
                                          // didn't match this, so the dots
                                          // lit up out of sequence. Labels
                                          // also now match the detail cards
                                          // below (SE / GD / Admin Final
                                          // Quotation / Admin Approval) so
                                          // the same milestone reads the same
                                          // way in both places.
                                          const steps = [
                                            {
                                              label: "Sales Executive",
                                              done:
                                                item?.sales_executive_id !=
                                                null,
                                            },
                                            {
                                              label: "Graphic Designer",
                                              done:
                                                item?.graphic_designer_id !=
                                                null,
                                            },
                                            {
                                              label: "Mockup",
                                              done:
                                                (item?.designs || []).length >
                                                0,
                                            },
                                            {
                                              label: "Supplier",
                                              done: !!item?.supplier_assigned,
                                            },
                                            {
                                              label: "Quotes",
                                              done: (item?.product || []).some(
                                                (p) =>
                                                  p?.quotation_price ||
                                                  p?.supplier_to_admin_quotation_price,
                                              ),
                                            },
                                            {
                                              // Admin sends the final
                                              // quotation to the buyer
                                              // (orders.final_price is set).
                                              // sendBuyerPrice only allows
                                              // this once admin/sub-admin has
                                              // already accepted a supplier's
                                              // quote ("Admin Approval" card
                                              // below), so reaching this step
                                              // guarantees that happened too.
                                              label: "Final Quote",
                                              done: item?.final_price != null,
                                            },
                                            {
                                              // The BUYER's own approval of
                                              // that final quotation — the
                                              // last gate before tracking.
                                              // Distinguished from the "Admin
                                              // Approval" card below, which is
                                              // an earlier, internal step.
                                              label: "Buyer Approval",
                                              done: (item?.product || []).some(
                                                (p) => p?.status === "approved",
                                              ),
                                            },
                                            {
                                              label: "Tracking",
                                              done: /track|complete|deliver/i.test(
                                                item?.order_status || "",
                                              ),
                                            },
                                          ];
                                          return (
                                            <div className="bpl-stepper">
                                              {steps.map((s, i) => (
                                                <div
                                                  className="bpl-step"
                                                  key={i}
                                                >
                                                  <div className="bpl-step__row">
                                                    <div
                                                      className={`bpl-step__dot ${s.done ? "is-done" : ""}`}
                                                    >
                                                      {s.done ? (
                                                        <svg
                                                          width="13"
                                                          height="13"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="currentColor"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                      ) : (
                                                        i + 1
                                                      )}
                                                    </div>
                                                    {i < steps.length - 1 && (
                                                      <div
                                                        className={`bpl-step__line ${s.done ? "is-done" : ""}`}
                                                      />
                                                    )}
                                                  </div>
                                                  <span
                                                    className={`bpl-step__lbl ${s.done ? "is-done" : ""}`}
                                                  >
                                                    {s.label}
                                                  </span>
                                                </div>
                                              ))}
                                            </div>
                                          );
                                        })()}
                                        <div className="bpl-cards">
                                          {/* Product specs + images */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Product Specs
                                            </div>
                                            <div className="bpl-ci__body">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 8,
                                                }}
                                              >
                                                <ProductImageStack
                                                  images={
                                                    item?.productInfo
                                                      ?.product_image
                                                  }
                                                  onOpen={() =>
                                                    setGalleryItem(item)
                                                  }
                                                />
                                                <button
                                                  type="button"
                                                  className="al-act al-act--primary"
                                                  title="View full product specs"
                                                  onClick={() =>
                                                    setSpecsItem(item)
                                                  }
                                                >
                                                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                                                </button>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Assign SE/GD (admin / non-subadmin) */}
                                          {user?.user_type !==
                                            "Graphic Designer" &&
                                            user?.user_type != "subadmin" && (
                                              <div className="bpl-ci">
                                                <div className="bpl-ci__lbl">
                                                  {user?.user_type === "admin"
                                                    ? "Assign SE / GD"
                                                    : "Assign"}
                                                </div>
                                                <div className="bpl-ci__body">
                                                  <button
                                                    type="button"
                                                    className="al-act al-act--primary"
                                                    title="Assign SE / GD"
                                                    style={{
                                                      cursor:
                                                        (user?.user_type ===
                                                          "admin" &&
                                                          item?.sales_executive_id !==
                                                            null &&
                                                          item?.graphic_designer_id !==
                                                            null) ||
                                                        (user?.user_type ===
                                                          "Sales Executive" &&
                                                          item?.graphic_designer_id !==
                                                            null)
                                                          ? "not-allowed"
                                                          : "pointer",
                                                      opacity:
                                                        (user?.user_type ===
                                                          "admin" &&
                                                          item?.sales_executive_id !==
                                                            null &&
                                                          item?.graphic_designer_id !==
                                                            null) ||
                                                        (user?.user_type ===
                                                          "Sales Executive" &&
                                                          item?.graphic_designer_id !==
                                                            null)
                                                          ? 0.5
                                                          : 1,
                                                    }}
                                                    onClick={() => {
                                                      const isDisabled =
                                                        (user?.user_type ===
                                                          "admin" &&
                                                          item?.sales_executive_id !==
                                                            null &&
                                                          item?.graphic_designer_id !==
                                                            null) ||
                                                        (user?.user_type ===
                                                          "Sales Executive" &&
                                                          item?.graphic_designer_id !==
                                                            null);
                                                      if (isDisabled) return;
                                                      const sales_executive_id =
                                                        item?.sales_executive_id;
                                                      handleOpenModal(
                                                        item?.user_id,
                                                      );
                                                    }}
                                                  >
                                                    <svg
                                                      width="15"
                                                      height="15"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                      <circle
                                                        cx="9"
                                                        cy="7"
                                                        r="4"
                                                      />
                                                      <line
                                                        x1="19"
                                                        y1="8"
                                                        x2="19"
                                                        y2="14"
                                                      />
                                                      <line
                                                        x1="22"
                                                        y1="11"
                                                        x2="16"
                                                        y2="11"
                                                      />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                            )}

                                          {/* Assign Graphic Designer (subadmin) */}
                                          {user?.user_type !==
                                            "Graphic Designer" &&
                                            user?.user_type == "subadmin" && (
                                              <div className="bpl-ci">
                                                <div className="bpl-ci__lbl">
                                                  Assign Graphic Designer
                                                </div>
                                                <div className="bpl-ci__body">
                                                  <button
                                                    type="button"
                                                    className="al-act al-act--primary"
                                                    title={
                                                      item?.graphic_designer_id !==
                                                      null
                                                        ? "Graphic designer already assigned"
                                                        : "Assign Graphic Designer"
                                                    }
                                                    style={{
                                                      // This block only ever renders for a
                                                      // subadmin (see the outer gate above),
                                                      // so a `user?.user_type === "admin"`
                                                      // check here could never be true — the
                                                      // button stayed enabled no matter what,
                                                      // even with a GD already assigned.
                                                      cursor:
                                                        item?.graphic_designer_id !==
                                                        null
                                                          ? "not-allowed"
                                                          : "pointer",
                                                      opacity:
                                                        item?.graphic_designer_id !==
                                                        null
                                                          ? 0.5
                                                          : 1,
                                                    }}
                                                    onClick={() => {
                                                      const isDisabled =
                                                        item?.graphic_designer_id !==
                                                        null;
                                                      if (isDisabled) return;
                                                      const sales_executive_id =
                                                        item?.sales_executive_id;
                                                      handleOpenModal(
                                                        item?.user_id,
                                                      );
                                                    }}
                                                  >
                                                    <svg
                                                      width="15"
                                                      height="15"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                      <circle
                                                        cx="9"
                                                        cy="7"
                                                        r="4"
                                                      />
                                                      <line
                                                        x1="19"
                                                        y1="8"
                                                        x2="19"
                                                        y2="14"
                                                      />
                                                      <line
                                                        x1="22"
                                                        y1="11"
                                                        x2="16"
                                                        y2="11"
                                                      />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                            )}

                                          {/* Supplier Assign Status */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Supplier Assign Status
                                            </div>
                                            <div className="bpl-ci__body">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 8,
                                                }}
                                              >
                                                {item?.supplier_assigned ? (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-success-bg)",
                                                      color:
                                                        "var(--color-success-text)",
                                                    }}
                                                  >
                                                    Assigned
                                                  </span>
                                                ) : (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-danger-bg)",
                                                      color:
                                                        "var(--color-danger-text)",
                                                    }}
                                                  >
                                                    Not Assigned
                                                  </span>
                                                )}
                                                {/* Assign Supplier — moved
                                                    here from the button row
                                                    below, same icon-button
                                                    pattern as Assign SE/GD.
                                                    Sourcing closes once the
                                                    buyer has been quoted
                                                    (final_price set), so hide
                                                    it then — the API would
                                                    just 400 the assignment. */}
                                                {item?.final_price == null && (
                                                  <button
                                                    type="button"
                                                    className="al-act al-act--primary"
                                                    title="Assign Supplier"
                                                    onClick={() => {
                                                      const supplierIds = [
                                                        ...new Set(
                                                          item?.product
                                                            ?.filter(
                                                              (i) =>
                                                                i.supplier_id !==
                                                                null,
                                                            )
                                                            .map(
                                                              (i) =>
                                                                i.supplier_id,
                                                            ),
                                                        ),
                                                      ];
                                                      Navigate(
                                                        "/admin/assign-supplier",
                                                        {
                                                          state: {
                                                            orderId:
                                                              item?.order_id,
                                                            supplierIds:
                                                              supplierIds,
                                                            product_id:
                                                              item?.product_id,
                                                            buyerUserId:
                                                              item?.user_id,
                                                            route: `/admin/buyer/product-list/${item.user_id}`,
                                                          },
                                                        },
                                                      );
                                                    }}
                                                  >
                                                    <svg
                                                      width="15"
                                                      height="15"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                      <circle
                                                        cx="9"
                                                        cy="7"
                                                        r="4"
                                                      />
                                                      <line
                                                        x1="19"
                                                        y1="8"
                                                        x2="19"
                                                        y2="14"
                                                      />
                                                      <line
                                                        x1="22"
                                                        y1="11"
                                                        x2="16"
                                                        y2="11"
                                                      />
                                                    </svg>
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          {/* SE Assign Status (admin) */}
                                          {user?.user_type === "admin" && (
                                            <div className="bpl-ci">
                                              <div className="bpl-ci__lbl">
                                                SE Assign Status
                                              </div>
                                              <div className="bpl-ci__body">
                                                {item?.sales_executive_id !=
                                                null ? (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-success-bg)",
                                                      color:
                                                        "var(--color-success-text)",
                                                    }}
                                                  >
                                                    Assigned
                                                  </span>
                                                ) : (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-warning-bg)",
                                                      color:
                                                        "var(--color-warning-text)",
                                                    }}
                                                  >
                                                    Pending
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          )}

                                          {/* GD Assign Status */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              GD Assign Status
                                            </div>
                                            <div className="bpl-ci__body">
                                              {user?.user_type === "subadmin" ||
                                              user?.user_type === "admin" ? (
                                                item?.graphic_designer_id ? (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-success-bg)",
                                                      color:
                                                        "var(--color-success-text)",
                                                    }}
                                                  >
                                                    Assigned
                                                  </span>
                                                ) : (
                                                  <span
                                                    className="al-pill"
                                                    style={{
                                                      background:
                                                        "var(--color-warning-bg)",
                                                      color:
                                                        "var(--color-warning-text)",
                                                    }}
                                                  >
                                                    Pending
                                                  </span>
                                                )
                                              ) : (
                                                <span className="al-muted">
                                                  —
                                                </span>
                                              )}
                                            </div>
                                          </div>

                                          {/* Supplier's Quotes */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Supplier's Quotes
                                            </div>
                                            <div className="bpl-ci__body">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 8,
                                                }}
                                              >
                                                {/* The finalized quote admin
                                                    approved with the winning
                                                    supplier — was just the
                                                    manage button with no
                                                    amount shown at all.
                                                    Finds the order_assigned
                                                    row the same way "Order
                                                    Status" above does
                                                    (approved > rejected >
                                                    waiting_for_final_approval
                                                    > pending), then reads its
                                                    latest negotiated price:
                                                    supplier's re-quote if
                                                    they countered, else
                                                    admin's counter, else
                                                    their original quote. */}
                                                {(() => {
                                                  const quote =
                                                    (item.product || []).find(
                                                      (p) =>
                                                        p.status ===
                                                        "approved",
                                                    ) ||
                                                    (item.product || []).find(
                                                      (p) =>
                                                        p.status ===
                                                        "rejected",
                                                    ) ||
                                                    (item.product || []).find(
                                                      (p) =>
                                                        p.status ===
                                                        "waiting_for_final_approval",
                                                    ) ||
                                                    (item.product || []).find(
                                                      (p) =>
                                                        p.status ===
                                                        "pending",
                                                    );
                                                  const price =
                                                    quote?.supplier_to_admin_quotation_price ??
                                                    quote?.admin_quotation_price ??
                                                    quote?.quotation_price;
                                                  return price ? (
                                                    <span
                                                      style={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        fontFamily:
                                                          "var(--font-mono)",
                                                        color:
                                                          "var(--color-text-primary)",
                                                      }}
                                                    >
                                                      {formatMoney(price)}
                                                    </span>
                                                  ) : (
                                                    <span className="al-muted">
                                                      —
                                                    </span>
                                                  );
                                                })()}
                                              <div
                                                style={{
                                                  position: "relative",
                                                  display: "inline-block",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  className="al-act"
                                                  title="View / manage supplier quotes"
                                                  onClick={() => {
                                                    const product = (
                                                      item.product || []
                                                    ).filter(
                                                      (i) =>
                                                        i.status ==
                                                        "waiting_for_final_approval",
                                                    );
                                                    Navigate(
                                                      `/admin/revert-back/supplier/${item.product_id}/${item?.order_id}`,
                                                      {
                                                        state: {
                                                          product_id:
                                                            item?.product_id,
                                                          order_assigned_id:
                                                            product?.[0]
                                                              ?.order_assigned_id,
                                                          title: item?.title,
                                                          quantity:
                                                            item?.quantity,
                                                          size: item?.size,
                                                          order_id:
                                                            item?.order_id,
                                                        },
                                                      },
                                                    );
                                                  }}
                                                >
                                                  <svg
                                                    width="15"
                                                    height="15"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  >
                                                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                                                    <line
                                                      x1="7"
                                                      y1="7"
                                                      x2="7.01"
                                                      y2="7"
                                                    />
                                                  </svg>
                                                </button>
                                                {request === "Send Quotation" &&
                                                  orderIds?.includes(
                                                    item?.order_id?.toString(),
                                                  ) && (
                                                    <span
                                                      style={{
                                                        position: "absolute",
                                                        top: "-2px",
                                                        right: "-2px",
                                                        width: "8px",
                                                        height: "8px",
                                                        backgroundColor: "red",
                                                        borderRadius: "50%",
                                                      }}
                                                    />
                                                  )}
                                              </div>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Graphic Designer Mockup */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Graphic Designer Mockup
                                            </div>
                                            <div className="bpl-ci__body">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  position: "relative",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    position: "relative",
                                                  }}
                                                >
                                                  {item.designs
                                                    ?.filter(
                                                      (d) => d?.design_url,
                                                    )
                                                    .slice(0, 3)
                                                    .map((d, i) => (
                                                      <img
                                                        key={`${d.design_url}_${i}`}
                                                        src={`${REACT_APP_IMAGE_URL}${d.design_url}`}
                                                        alt="design"
                                                        title="View designs"
                                                        style={{
                                                          width: 34,
                                                          height: 34,
                                                          borderRadius: 9,
                                                          cursor: "pointer",
                                                          objectFit: "cover",
                                                          border:
                                                            "2px solid var(--color-surface)",
                                                          background:
                                                            "var(--color-surface-2)",
                                                          position: "relative",
                                                          zIndex: 10 - i,
                                                          marginLeft:
                                                            i === 0 ? 0 : -10,
                                                        }}
                                                        onError={(e) => {
                                                          e.currentTarget.style.display =
                                                            "none";
                                                        }}
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          // Same lightweight
                                                          // viewer product
                                                          // images and media
                                                          // files already use
                                                          // — this used to
                                                          // open the full
                                                          // "manage designs"
                                                          // editor instead of
                                                          // just showing the
                                                          // picture.
                                                          setDesignGalleryImages(
                                                            item.designs
                                                              .filter(
                                                                (dd) =>
                                                                  dd?.design_url,
                                                              )
                                                              .map(
                                                                (dd) =>
                                                                  dd.design_url,
                                                              ),
                                                          );
                                                        }}
                                                      />
                                                    ))}
                                                  {item.designs?.filter(
                                                    (d) => d?.design_url,
                                                  ).length > 3 && (
                                                    <div
                                                      style={{
                                                        width: 34,
                                                        height: 34,
                                                        borderRadius: 9,
                                                        backgroundColor:
                                                          "var(--color-surface-2)",
                                                        color:
                                                          "var(--color-text-secondary)",
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        marginLeft: -10,
                                                        border:
                                                          "2px solid var(--color-surface)",
                                                      }}
                                                    >
                                                      +
                                                      {item.designs.filter(
                                                        (d) => d?.design_url,
                                                      ).length - 3}
                                                    </div>
                                                  )}
                                                </div>
                                                {request === "Create Mokeup" &&
                                                  orderIds?.includes(
                                                    item?.order_id?.toString(),
                                                  ) && (
                                                    <span
                                                      style={{
                                                        position: "absolute",
                                                        top: "-2px",
                                                        right: "-2px",
                                                        width: "8px",
                                                        height: "8px",
                                                        backgroundColor: "red",
                                                        borderRadius: "50%",
                                                      }}
                                                    />
                                                  )}
                                              </div>
                                            </div>
                                          </div>

                                          {/* Admin Approval (admin) */}
                                          {user.user_type === "admin" && (
                                            <div className="bpl-ci">
                                              <div className="bpl-ci__lbl">
                                                Admin Approval
                                              </div>
                                              <div className="bpl-ci__body">
                                                {(() => {
                                                  const product = (
                                                    item.product || []
                                                  ).find(
                                                    (i) =>
                                                      i.status ===
                                                      "waiting_for_final_approval",
                                                  );
                                                  const isDisabled =
                                                    !product ||
                                                    product.status ==
                                                      "approved" ||
                                                    item.final_price != null;
                                                  // isDisabled only says the toggle
                                                  // can't be clicked — it is also true
                                                  // before any quote exists, which made
                                                  // brand-new orders render as green
                                                  // "Approved".
                                                  //
                                                  // Admin approval is recorded as
                                                  // final_price on the order (see
                                                  // sendBuyerPrice); order_assigned only
                                                  // flips to "approved" later, when the
                                                  // BUYER approves. So both count as on.
                                                  const isApproved =
                                                    item.final_price != null ||
                                                    (item.product || []).some(
                                                      (p) =>
                                                        p?.status ===
                                                        "approved",
                                                    );
                                                  return (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 9,
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        className={`al-toggle ${isApproved ? "is-on" : ""}`}
                                                        title={
                                                          isApproved
                                                            ? "Approved"
                                                            : "Approve"
                                                        }
                                                        style={{
                                                          cursor: isDisabled
                                                            ? "not-allowed"
                                                            : "pointer",
                                                          opacity: isDisabled
                                                            ? 0.85
                                                            : 1,
                                                        }}
                                                        onClick={() => {
                                                          if (isDisabled)
                                                            return;
                                                          HandleActiveDeactive(
                                                            product.order_assigned_id,
                                                            item?.supplier_to_admin_quotation_price
                                                              ? item?.supplier_to_admin_quotation_price
                                                              : item.final_price,
                                                            product.status,
                                                            product.admin_quotation_price
                                                              ? product.supplier_to_admin_quotation_price
                                                              : product.quotation_price,
                                                            item?.order_id,
                                                          );
                                                        }}
                                                      >
                                                        <span className="al-toggle__knob" />
                                                      </button>
                                                      <span
                                                        style={{
                                                          fontSize: 11.5,
                                                          fontWeight: 700,
                                                          color: isApproved
                                                            ? "var(--color-success-text)"
                                                            : "var(--color-text-secondary)",
                                                        }}
                                                      >
                                                        {isApproved
                                                          ? "Approved"
                                                          : "Pending"}
                                                      </span>
                                                      {/* Without this the grey
                                                          toggle reads as a status
                                                          badge and nobody realises
                                                          it can be clicked. */}
                                                      {!isDisabled &&
                                                        !isApproved && (
                                                          <span
                                                            style={{
                                                              fontSize: 10.5,
                                                              fontWeight: 700,
                                                              color:
                                                                "var(--color-primary)",
                                                            }}
                                                          >
                                                            Tap to approve
                                                          </span>
                                                        )}
                                                    </div>
                                                  );
                                                })()}
                                              </div>
                                            </div>
                                          )}

                                          {/* Admin Final Quotation */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Admin Final Quotation
                                            </div>
                                            <div className="bpl-ci__body">
                                              {/* Was a bordered price box sat
                                                  inside a button next to a
                                                  loose info icon — two nested
                                                  boxes reading as one broken
                                                  control. One button now. */}
                                              <button
                                                type="button"
                                                className={`al-btn ${
                                                  item?.final_price == null
                                                    ? "al-btn--primary"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  handleOpenFinalQuotation(
                                                    item,
                                                  )
                                                }
                                                title={
                                                  item?.final_price == null
                                                    ? "Set the admin final quotation"
                                                    : "View the admin final quotation"
                                                }
                                              >
                                                {item?.final_price == null
                                                  ? "Set quotation"
                                                  : formatMoney(
                                                      item.final_price,
                                                    )}
                                              </button>
                                            </div>
                                          </div>

                                          {/* Order Status */}
                                          <div className="bpl-ci">
                                            <div className="bpl-ci__lbl">
                                              Order Status
                                            </div>
                                            <div className="bpl-ci__body">
                                              <span
                                                className="al-pill"
                                                style={{
                                                  background: st.bg,
                                                  color: st.color,
                                                }}
                                              >
                                                {item.order_status || "—"}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Actions */}
                                        {/* Assign Supplier now lives in the
                                            Supplier Assign Status card above
                                            (same icon-button pattern as
                                            Assign SE/GD); Set Admin Final
                                            Quotation and View full order are
                                            removed per request. */}
                                        <div className="bpl-actions">
                                          <div
                                            style={{
                                              marginLeft: "auto",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 8,
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="al-act"
                                              title="Call"
                                              style={{ color: "#34B7F1" }}
                                              onClick={() =>
                                                handleCallClick(
                                                  item.user?.phone,
                                                )
                                              }
                                            >
                                              <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              >
                                                <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 3.1 5.18 2 2 0 0 1 5 3h3a2 2 0 0 1 2 1.72 12 12 0 0 0 .56 2.57 2 2 0 0 1-.45 2.11L9 11a16 16 0 0 0 5 5l1.6-1.1a2 2 0 0 1 2.1-.45 12 12 0 0 0 2.57.56A2 2 0 0 1 22 16.92z" />
                                              </svg>
                                            </button>
                                            <button
                                              type="button"
                                              className="al-act"
                                              title="WhatsApp"
                                              style={{ color: "#25D366" }}
                                              onClick={() =>
                                                handleWhatsAppClick(
                                                  item.user?.phone,
                                                )
                                              }
                                            >
                                              <svg
                                                width="15"
                                                height="15"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              >
                                                <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 014 11.5a8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <div className="al-empty">
                                <p className="al-empty__title">
                                  No Record Found
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <Modal
                      open={showApprovalModal}
                      onClose={() => setShowApprovalModal(false)}
                      title="Final Quotation"
                      subtitle="Set the price sent to the buyer, then approve or reject."
                      size="sm"
                      footer={
                        <>
                          <button
                            type="button"
                            className="al-btn"
                            style={{
                              background: "var(--color-danger-bg)",
                              color: "var(--color-danger-text)",
                              border: 0,
                            }}
                            onClick={() => {
                              setStatus(0);
                              setTimeout(
                                () => AddFinalQuotation.handleSubmit(),
                                0,
                              );
                            }}
                          >
                            Reject
                          </button>
                          <button
                            type="button"
                            className="al-btn al-btn--primary"
                            onClick={() => {
                              setStatus(1);
                              setTimeout(
                                () => AddFinalQuotation.handleSubmit(),
                                0,
                              );
                            }}
                          >
                            Approve
                          </button>
                        </>
                      }
                    >
                      {/* oldPrice is the accepted supplier quote (the same
                          value the "must be more than" validation below
                          checks against) — it was already being used, just
                          never shown, so admin had no way to see what
                          they're marking up without guessing or triggering
                          the validation error first. */}
                      <div
                        className="al-field"
                        style={{
                          background: "var(--color-surface-2)",
                          border: "1px solid var(--color-border)",
                          borderRadius: 10,
                          padding: "10px 14px",
                          marginBottom: 4,
                        }}
                      >
                        <span
                          className="al-label"
                          style={{ marginBottom: 2 }}
                        >
                          Accepted Supplier Price
                        </span>
                        <div
                          style={{
                            fontSize: 16,
                            fontWeight: 700,
                            fontFamily: "var(--font-mono)",
                          }}
                        >
                          {formatMoney(oldPrice)}
                        </div>
                      </div>

                      <div className="al-field">
                        <label className="al-label">Price</label>
                        <input
                          className="al-input"
                          type="text"
                          placeholder="Enter price"
                          value={AddFinalQuotation.values.final_price}
                          onChange={AddFinalQuotation.handleChange}
                          onBlur={AddFinalQuotation.handleBlur}
                          name="final_price"
                        />
                        {AddFinalQuotation.errors.final_price &&
                          AddFinalQuotation.touched.final_price && (
                            <span className="al-err">
                              {AddFinalQuotation.errors.final_price}
                            </span>
                          )}
                      </div>

                      <div className="al-field">
                        <label className="al-label">Description</label>
                        <textarea
                          className="al-textarea"
                          placeholder="Enter description"
                          value={AddFinalQuotation.values.final_description}
                          onChange={AddFinalQuotation.handleChange}
                          onBlur={AddFinalQuotation.handleBlur}
                          name="final_description"
                          rows="4"
                        />
                        {AddFinalQuotation.errors.final_description &&
                          AddFinalQuotation.touched.final_description && (
                            <span className="al-err">
                              {AddFinalQuotation.errors.final_description}
                            </span>
                          )}
                      </div>
                    </Modal>

                    <GraphicDesingerMokup
                      show={showDesignModal}
                      userId={usersId}
                      orderId={orderId}
                      onClose={handleDesignCloseModal}
                    />

                    <SupplierApprovalQuotes
                      show={showSupplierQuotesModal}
                      userId={usersId}
                      orderId={orderId}
                      prodcutData={productApprovalData}
                      onClose={handleSupplierApprovalQuotesCloseModal}
                    />
                    <AdminFinalQuotation
                      show={showFinalApprovalModal}
                      order={selectedFinalOrder}
                      onClose={handleFinalCloseModal}
                    />

                    {/* Product image gallery (thumbnail stack) */}
                    <ProductImagesModal
                      open={!!galleryItem}
                      onClose={() => setGalleryItem(null)}
                      images={galleryItem?.productInfo?.product_image}
                      title={galleryItem?.title || "Product Images"}
                    />

                    {/* Design-mockup image viewer — same lightweight modal as
                        product images / media files, opened by clicking a
                        design thumbnail directly. */}
                    <ProductImagesModal
                      open={!!designGalleryImages}
                      onClose={() => setDesignGalleryImages(null)}
                      images={designGalleryImages}
                      title="Design Mockups"
                    />

                    {/* Full product specs + images (eye icon) */}
                    <OrderSpecsModal
                      open={!!specsItem}
                      onClose={() => setSpecsItem(null)}
                      order={specsItem}
                      product={specsItem?.productInfo}
                      buyer={specsItem?.user}
                      extraFields={[
                        {
                          label: "Suppliers Assigned",
                          value: (specsItem?.product || []).length,
                        },
                        {
                          label: "Designs Uploaded",
                          value: (specsItem?.designs || []).length,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex justify-content-center">
                    <div
                      className="dataTables_paginate paging_full_numbers"
                      id="alter_pagination_paginate"
                    >
                      {data?.length !== 0 ? (
                        <ReactPaginate
                          previousLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-left"
                            >
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                          }
                          nextLabel={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#515365"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-arrow-right"
                            >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                          }
                          breakLabel={"..."}
                          pageCount={totalpage}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-end m-0"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showGDModal && (
          <AddGraphicDesignModal
            show={showGDModal}
            setShow={setShowGDModal}
            fetchProducts={ProductData}
            orderId={orderId}
            onClose={handleCloseGDModal}
          />
        )}
        <AssignSalesExecutiveModal
          show={showModal}
          userId={userId}
          usertype={"buyer"}
          orderType={"Offline Buyer"}
          onClose={handleCloseModal}
        />

        <AssignSalesExecutiveAddForm
          show={showAddModal}
          userId={selectedUsers}
          onClose={handleAddCloseModal}
        />
      </div>
    </>
  );
};

export default ProductListBuyer;
